// NOTE: Keep these types in sync with the corresponding definitions in publishing/types.py.
//
// TODO: extend the generate_client_sources management command to automatically generate TS types
// from python sources, then create this file by feeding publishing/types.py into it.

import { InteractionMode, PublicationType } from "../components/server-types";

export enum ChangeAction {
  create = "create",
  update = "update",
  delete = "delete",
}

export type PageChangeSummary = {
  action: ChangeAction;
  id: string;
  interaction_mode: InteractionMode;
  order: number;
  title: string;
};

export type TopicChangeSummary = {
  action: ChangeAction;
  id: string;
  order: number;
  title: string;
  archive_pages: PageChangeSummary[];
  lesson_pages: PageChangeSummary[];
  prep_pages: PageChangeSummary[];
  resource_pages: PageChangeSummary[];
};

export type PublicationSummary = {
  authors: string[];
  topics: TopicChangeSummary[];
  assignments: PageChangeSummary[];
  resources: PageChangeSummary[];
  workspaces: PageChangeSummary[];
  excluded_pages: PageChangeSummary[];
};

export type UpdateDraftPublicationResponse = {
  publication: PublicationType;
  deleted_publication_id: string | null;
};
